export enum ChangePercentAlertType {

    Hourly = 1,
    Daily = 2,
    FromNow = 3,
}
